import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, CheckCheck } from 'lucide-react';
import './SupplierHeader.css';

export default function SupplierHeader({ title, subtitle, unread, notifications, onMarkAllRead }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const getArtworkId = (notification) => {
    if (!notification?.artworkId) return null;
    if (typeof notification.artworkId === 'string') return notification.artworkId;
    return notification.artworkId._id || notification.artworkId.id || null;
  };

  const handleNotificationClick = (notification) => {
    const artworkId = getArtworkId(notification);
    setOpen(false);
    if (artworkId) {
      navigate(`/supplier/artworks/${artworkId}`);
    }
  };

  return (
    <header className="supplier-page-header">
      <div>
        <h1 className="supplier-header-title">{title}</h1>
        {subtitle && <p className="supplier-header-subtitle">{subtitle}</p>}
      </div>

      <div className="supplier-header-actions" ref={ref}>
        <button className="supplier-notif-btn" onClick={() => setOpen(!open)}>
          <Bell size={20} />
          {unread > 0 && <span className="supplier-notif-badge">{unread > 9 ? '9+' : unread}</span>}
        </button>

        {open && (
          <div className="supplier-notif-dropdown animate-fadeInUp">
            <div className="supplier-notif-header">
              <span className="supplier-notif-header-title">Notifications</span>
              {unread > 0 && (
                <button className="supplier-notif-mark-all" onClick={onMarkAllRead}>
                  <CheckCheck size={14} /> Mark all read
                </button>
              )}
            </div>

            <div className="supplier-notif-list">
              {(!notifications || notifications.length === 0) ? (
                <div className="supplier-notif-empty">
                  <Bell size={24} />
                  <p>No notifications yet</p>
                </div>
              ) : (
                notifications.slice(0, 10).map(n => (
                  <div
                    key={n._id}
                    className={`supplier-notif-item ${!n.isRead ? 'unread' : ''}`}
                    onClick={() => handleNotificationClick(n)}
                  >
                    <div className="supplier-notif-content">
                      <p className="supplier-notif-title">{n.title}</p>
                      <p className="supplier-notif-msg">{n.message}</p>
                    </div>
                    {!n.isRead && <span className="supplier-notif-dot" />}
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
